import styled from 'styled-components';

export const BrowseSection = styled.div`
  padding: ${(props) => (props.padding ? '20px 7.5%' : '0')};
  margin: 40px 0;
  background:;

  ${(props) =>
    props.isForNewCdPage &&
    `
        @media (min-width: 1024px) {
            width: 75%;
            margin: 0 auto;
            margin-bottom: 20px;
        }
    `}

  background: ${(props) =>
    props.isForNewCdPage
      ? 'linear-gradient(to bottom, rgba(251, 212, 106, 0.3) 0%, rgba(251, 212, 106, 0.1) 50%, #fff 100%)'
      : `linear-gradient(
        to bottom,
        ${(props) => props.sectionBgColorStart},
        ${(props) => props.sectionBgColorEnd}
    )`};
  @media (max-width: 720px) {
    padding: ${(props) => (props.padding ? '20px 0' : '0')};
    margin: 0;
  }
  &.shakeanimation {
    animation: shakeButton 1s ease;

    @keyframes shakeButton {
      10%,
      90% {
        transform: translate3d(-1px, 0, 0);
      }

      20%,
      80% {
        transform: translate3d(2px, 0, 0);
      }

      30%,
      50%,
      70% {
        transform: translate3d(-4px, 0, 0);
      }

      40%,
      60% {
        transform: translate3d(4px, 0, 0);
      }
    }
  }
`;

export const BrowseAllProductsContainer = styled.div`
  grid-template-columns: repeat(${(props) => props.gridSize}, 1fr);
  display: grid;
  padding: 10px 6px;
  justify-items: center;
  @media (max-width: 720px) {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 0;
    overflow: auto;
  }
`;
